export default [
  {
    path: "settings/company/positions",
    name: "settingsPositions",
    component: () => import("../components/positions/PositionSettingsPage"),
  },
];
